export default class UserInfo {
  public email?: string
  public firstname?: string
  public lastname?: string
  public firstKanaName?: string
  public lastKanaName?: string
  public password?: string
  public organization?: string
  public jobRoles?: string
  public phone: string
  public mobilePhone: string
  public countryRegion: string
  public address: string
  public city: string
  public state: string
  public zipCode: string
  public department: string
  public industry: string
  public emailSubscription?: boolean
  public productCategory?: number[]
  public field?: number[]
  public updateDttm?: string
  public locale?: string

  constructor() {
    this.email = ''
    this.firstname = ''
    this.lastname = ''
    this.firstKanaName = ''
    this.lastKanaName = ''
    this.password = ''
    this.organization = ''
    this.jobRoles = ''
    this.phone = ''
    this.mobilePhone = ''
    this.countryRegion = ''
    this.address = ''
    this.city = ''
    this.state = ''
    this.zipCode = ''
    this.department = ''
    this.industry = ''
    this.locale = ''
  }
}
